import React, { useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress,  Tooltip } from "@mui/material";
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import FormikControl from '../../components/FormikControl/FormikControl';

import { Edit } from '@mui/icons-material';
import { Alert, Snackbar } from '@mui/material'

import feesStructureServices from '../feesStructureServices';




export default function FeesStructureForm({refreshList, data=null}) {

    const [formValues, setFormValues] = useState(null);
    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);


    const [snackStatus, setSnackStatus] = useState(false);
    const [snackMessage, setSnackMessage] = useState("");
    const [snackType, setSnackType] = useState("error");


    const initialValues = {
        title: "",
        amount:"",
    }

    const onSubmit = (values, onSubmitProps) => {
        console.log(values);
        //setSavingStatus(true)

        feesStructureServices.save(values).then(res =>{
            setSavingStatus(false);
            console.log(res);
            if(res.error){
                setSnackStatus(true);
                setSnackType("error");
                setSnackMessage(res.msg);
            } else {
                refreshList();
                setSnackStatus(true);
                setSnackType("success");
                setSnackMessage(res.msg);
                setDialogStatus(false);
            }
        })
    }

    const validationRule = Yup.object({
        title: Yup.string().required("Required"),
        amount: Yup.string().required("Required"),
    });

    const addNew = ()=>{
        setFormValues(initialValues);
        setDialogStatus(true)
    }

    const updateData = ()=>{

        let autoFill = {
            id:data.id,
            title:data.title,
            amount:data.amount,
        }
        setFormValues(autoFill);
        
        setDialogStatus(true)
    }

    const handleClose  = () =>{
        setDialogStatus(false);
    }


    return (
      <>
          {!data && <button className="btn btn-primary btn-sm" onClick={addNew}> Add New</button>
          
          
          
          }
          {data && 
            <>
            
            
                <Tooltip title="Update">
                    <IconButton onClick={updateData} style={{padding:"0px"}}>
                        <Edit/>
                    </IconButton>
                </Tooltip>
            
            </>
         }

        
            <Snackbar open={snackStatus} onClose={ ()=>{setSnackStatus(false)} } autoHideDuration={10000}  anchorOrigin={{ vertical: 'top', horizontal: 'center',  }}>
                <Alert  severity={snackType} sx={{ width: '100%' }}> {snackMessage}</Alert>
            </Snackbar>

            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
                maxWidth="sm"
                aria-describedby="alert-dialog-slide-description"
            >

                <Formik
                    initialValues={formValues || initialValues}
                    validationSchema={validationRule}
                    onSubmit={onSubmit}
                    enableReinitialize validateOnMount
                >
                    {
                        (formik) => {
                            //console.log(formik.values);
                            return (
                                <Form>
                                    <DialogTitle>Manage Fees</DialogTitle>
                                    <DialogContent>
                                        <div className="row p-2">
                                            
                                            <div className="col-md-12">

                                                <div className="row">

                                                    <FormikControl control="input" formik={formik} 
                                                        label="Title" name="title" 
                                                        className="col-6 " 
                                                    />

                                                    <FormikControl control="input" formik={formik} 
                                                        label="Amount" name="amount" 
                                                        className="col-6" 
                                                    />

                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                        {   /*JSON.stringify(formik.values) */}
                                        </div>

                                        {savingInProgress && <div className="row"><LinearProgress/></div> }
                                    </DialogContent>
                                    <DialogActions>
                                        {!savingInProgress && 
                                            <>
                                            <button className="btn btn-success" type="submit">Save</button>
                                            <button className="btn btn-danger" type="button" onClick={handleClose}>Cancel</button>
                                            </>
                                        }
                                        
                                    </DialogActions>
                                </Form>
                            )
                        }
                    }
                </Formik>
            </Dialog>
      </>
    )
}